@let online = (isOnline$ | async) ?? false;

@if (hasLoaded$ | async) {
  <button
    #originRef
    type="button"
    (click)="openPopover()"
    [class.opacity-70]="dropdownOpen"
    class="flex items-center gap-1.5 hover:opacity-80 transition-opacity">
    <span
      class="h-2 w-2 rounded-full flex-none"
      [ngClass]="{ 'bg-success': online, 'bg-danger': !online }"></span>
    <span class="text-[13px] font-medium text-default whitespace-nowrap">{{
      online ? "Shop open" : "Shop closed"
    }}</span>
  </button>
}
